const btnIcons = {
  deleteIcon: '/images/btn_icon/ic_delete_outline_red_24dp.svg',
  copyIcon: '/images/btn_icon/ic_content_copy_black_24dp.svg',
  resetIcon: '/images/btn_icon/ic_settings_backup_black_24dp.svg',
  backIcon: '/images/btn_icon/ic_chevron_left_black.svg',
  refreshIcon: '/images/btn_icon/ic_refresh_black_20dp.svg',
  closeIcon: '/images/btn_icon/ic_popup_close_black_24dp.svg',
  emergencyIcon: '/images/btn_icon/ic_close_white_24dp.svg',
  plusIcon: '/images/btn_icon/ic_bo_plus_white_24dp.svg',
  plusIconBlack: '/images/btn_icon/ic_dashboard_plus_black_20dp.svg',
  minusIconBlack: '/images/btn_icon/ic_dashboard_remove_black_20dp.svg',
  upLoadIcon: '/images/btn_icon/ic_upload_white_24dp.svg',
  upLoadPurpleIcon: '/images/btn_icon/ic_upload_purple_24dp.svg',
  downloadIcon: '/images/btn_icon/ic_download_purple_24dp.svg',
  hideIcon: '/images/btn_icon/ic_hide_black_24dp.svg',
  cancelIcon: '/images/btn_icon/ic_cancel_gray_24dp.svg',
  alertIcon: '/images/btn_icon/Property 1=ALERT.svg',
  warningIcon: '/images/btn_icon/Property 1=WARNING.svg',
};

export default btnIcons;
